'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getLayout = require('./getLayout.web');

var _getLayout2 = _interopRequireDefault(_getLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LayoutMixin = {
  getInitialState: function getInitialState() {
    return { layout: {} };
  },

  componentDidMount: function componentDidMount() {
    this.layoutHandle();
  },

  componentDidUpdate: function componentDidUpdate() {
    this.layoutHandle();
  },

  layoutHandle: function layoutHandle() {
    if (this.props.onLayout) {

      var layout = (0, _getLayout2["default"])(_reactDom2["default"].findDOMNode(this));
      var stateLayout = this.state.layout;
      if (stateLayout.x !== layout.x || stateLayout.y !== layout.y || stateLayout.width !== layout.width || stateLayout.height !== layout.height) {
        this.props.onLayout({ nativeEvent: { layout: layout } });
        this.setState({ layout: layout });
      }
    }
  }
};
// 'use strict';

module.exports = {
  Mixin: LayoutMixin
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-list-view/lib/Utilties/LayoutMixin.js
 ** module id = 428
 ** module chunks = 0
 **/